type SbefCodeSanitationAndDemolition =
  '00' | '01' | '02' | '03' | '04' | '05' | '06' | '07' | '08' | '09';

type SbefCodeGround =
  '10' | '11' | '12' | '13' | '14' | '15' | '16' | '17' | '18' | '19';

type SbefCodeHouseSubstructure =
  '20' | '21' | '22' | '23' | '24' | '25' | '26' | '27' | '28' | '29';
type SbefCodeFramework =
  '30' | '31' | '32' | '33' | '34' | '35' | '36' | '37' | '38' | '39';
type SbefCodeOuterRoof =
  '40' | '41' | '42' | '43' | '44' | '45' | '46' | '47' | '48' | '49';
type SbefCodeFacades =
  '50' | '51' | '52' | '53' | '54' | '55' | '56' | '57' | '58' | '59';
type SbefCodeFrameCompletionRoomForm =
  '60' | '61' | '62' | '63' | '64' | '65' | '66' | '67' | '68' | '69';
type SbefCodeInteriorSurfaceLayersRoomCompletion =
  '70' | '71' | '72' | '73' | '74' | '75' | '76' | '77' | '78' | '79';
type SbefCodeInstallations =
  '80' | '81' | '82' | '83' | '84' | '85' | '86' | '87' | '88' | '89';
type SbefCodeCommonWorks =
  '90' | '91' | '92' | '93' | '94' | '95' | '96' | '97' | '98' | '99';

/**
 * Note that this in not a valid group. Just packaged like that in the code for convenience.
 */
type SbefCodeOther = '101' | '102' | '103' | '104' | '105';

/**
 * Group codes
 */
export enum SbefGroupCode {
  SanitationAndDemolition = '0',
  Ground = '1',
  HouseSubstructure = '2',
  Framework = '3',
  OuterRoof = '4',
  Facades = '5',
  FrameCompletionRoomForm = '6',
  InteriorSurfaceLayersRoomCompletion = '7',
  Installations = '8',
  CommonWorks = '9',

  /**
   * Other is not a common group. Just packaged like that in the code for convenience.
   */
  //   Other = '10',
}

export const sbefGroupIds = Object.values(SbefGroupCode);

export const sbefDividerItems: SbefCode[] = [...sbefGroupIds];

/**
 * The child codes of each group
 */
type SbefItemCode =
  | SbefCodeSanitationAndDemolition
  | SbefCodeGround
  | SbefCodeHouseSubstructure
  | SbefCodeFramework
  | SbefCodeOuterRoof
  | SbefCodeFacades
  | SbefCodeFrameCompletionRoomForm
  | SbefCodeInteriorSurfaceLayersRoomCompletion
  | SbefCodeInstallations
  | SbefCodeCommonWorks
  | SbefCodeOther;

/**
 * The SBEF codes are the combination of the item codes and the group codes
 */
export type SbefCode = SbefItemCode | SbefGroupCode;

/**
 * The extra information for each SBEF code (label and lifetime)
 */
export type SbefEntry = {
  /**
   * The code of the SBEF code
   */
  code: string;

  /**
   * The name of the SBEF code
   */
  name: string;

  /**
   * Description of the SBEF code
   */
  description?: string;

  /**
   * Define lifetime to override default lifetime for the code
   */
  lifetime?: number;
};

/**
 * The record of all SBEF codes and their extra information
 */
export type SbefCodeRecord = Record<SbefCode, SbefEntry>;
